const LOG_DEVICE_WHITELIST = '/log-device-whitelist';

export const ROUTE_HOME_LOG_DEVICE_WHITELIST = LOG_DEVICE_WHITELIST + '/home';

export const logDeviceWhitelistRoutes = [ROUTE_HOME_LOG_DEVICE_WHITELIST];